import { types } from "../action-types";

const initialState = {
    loading: false,
    location: [],
    success: false,
    error: false,
};

const getPersonalDetailsLocationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_PERSONALDETAILSLOCATION_REQUESTED:
            return {
                ...state,
                success: false,
                loading: true,
            };

        case types.GET_PERSONALDETAILSLOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                location: action.payload,
                error: false,
            };
        case types.GET_PERSONALDETAILSLOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                location: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getPersonalDetailsLocationReducer;
